<template>
    <div class="app">
       <img class="app-img0" src="../../assets/img/bg00.jpg">
       <div class="app-con" :style="{height:height}">
           <img class="app-img1" src="../../assets/img/bg3.png" mode="widthFix">
           <!-- <div class="app-btn1" @touchstart="startFu" @touchmove="moveFu" @touchend="recordingFn"></div> -->
           <div class="app-btn2" @touchstart="startFu" @touchmove="moveFu" @touchend="btnFu"></div>
           <!-- <div v-if="!isapp" class="app-btn1" @touchstart="startFu" @touchmove="moveFu" @touchend="recordingFn"></div>
           <div v-if="!isapp" class="app-btn2" @touchstart="startFu" @touchmove="moveFu" @touchend="btnFu"></div> -->
           <!-- <button v-if="isapp" class="app-btn1" @getuserinfo="appBtnFu1" open-type="getUserInfo"></button> -->
           <!-- <button v-if="isapp" class="app-btn2" @getuserinfo="appBtnFu" open-type="getUserInfo"></button> -->
       </div>
       <!-- 中奖信息 -->
       <!-- <div class="app-wins" v-if="isshow">
            <div class="app-win">
                <img v-if="iswin!=1" src="../../assets/img/bg4.png">
                <img v-if="iswin==1" src="../../assets/img/bg5.png">
                <div class="app-win-btns" @touchstart="startFu" @touchmove="moveFu" @touchend="winBtnsFu"></div>
            </div>
       </div> -->
       <caiToast ref="caiToast"></caiToast>
       <!-- <div class="app-clear" @touchstart="startFu" @touchmove="moveFu" @touchend="clearFu">重置</div> -->
       <caiRegister v-if="isRegister"></caiRegister>
       <recording v-if="isRecording" @closeClick="recordingFn"></recording><!--v-if="isRecording"-->
    </div>
</template>
<script>
import caiToast from '#/toast';//引入提示插件
import caiRegister from '@/components/register';//引入登陆组件
import recording from '@/components/recording';
import wx from 'weixin-js-sdk';
export default {
  data () {
    return {
        start:0,
        height:'1206rpx',
        isshow:false,//是否显示中奖信息
        iswin:false,//是否中奖
        isanswer:false,//是否已经打题
        isinfo:false,//是否已经填写过信息
        isShowWin:false,//是否显示过中奖信息
        url:"",
        isapp:false,//是否是小程序
        isajax:false,//是否正在请求
        isRegister:false,//是否要登陆
        isRecording: false,
        wt:"",
        
    }
  },
  components: {
    caiToast,caiRegister,recording
  },
  created(){
    // let h = this.getwindowHeight();
    // if(h>700){//如果是苹果X
    //     let px = localStorage?'12.06rem':'1206rpx';
    //     this.height = px;
    // }
     if(!localStorage){
         this.isapp = true;
     }else{
         this.isapp = false;
     }
  },
  beforeMount(){
      this.init();
   // this.activity_idFu();//动态信息玩一玩
  },
  methods: {
     initremove(){
        if(localStorage){
             localStorage.clear();
        }else{
            wx.removeStorageSync('isinfo')
            wx.removeStorageSync('isanswer')
            wx.removeStorageSync('isShowWin')
        }
     }, 
     init(){
        let h = this.getwindowHeight();
        if(h>700){//如果是苹果X
            let px = localStorage?'12.06rem':'1206rpx';
            this.height = px;
        } 
        if(this.$store.state.is_award>0){
            this.iswin = this.$store.state.is_award;
            this.isshow = true;
            //设置isanswer为已答题
            let data = this.$store.state.status;
            data.isanswer = 1;
            this.$store.commit('setStatus',data);
        }
     },
     startFu(){this.start = 0;},
     moveFu(){this.start = 1;},
     validateFu(){//验证
         this.isanswer = this.$store.state.status.isanswer?true:false;
         this.isinfo = this.$store.state.status.msg?true:false;
         
         if(this.isanswer){//如果填写过打题
             this.$refs.caiToast.showFu({
                 msg:'你已经参加过此问卷调查，谢谢你的参与',
                 time:1500
            })
            return;
         }
         if(this.$store.state.status.time != 1){
             this.$refs.caiToast.showFu({
                 msg:'不在活动时间内!',
                 time:1500
            })
            return;
         }
         this.url = '/pages/info/main';
         this.isinfo && (this.url = '/pages/answer/main');//如果已经填写过信息
     },
     linkFu(){//跳转
        this.$refs.caiToast.showFu({
              msg:'正在跳转，请稍等',
              time:1500
          })
          setTimeout(()=>{
             this.isajax = false;  
             this.$router.push(this.url);
          },1500)
     },
     appBtnFu(res){//小程序接口
       // console.log(res);
         if(this.isajax){return;}
         this.isanswer = this.$store.state.status.isanswer?true:false;
         this.isinfo = this.$store.state.status.msg?true:false;
         
         if(this.isanswer){//如果填写过打题
             this.$refs.caiToast.showFu({
                 msg:'你已经参加过此问卷调查，谢谢你的参与',
                 time:1500
            })
            return;
         }
         if(this.$store.state.status.time != 1){
             this.$refs.caiToast.showFu({
                 msg:'不在活动时间内!',
                 time:1500
            })
            return;
         }
         this.$router.push({ name: "Identity" })
        //  this.url = '/pages/Identity/main'
        //  this.url = '/pages/info/main';
        //  this.isinfo && (this.url = '/pages/answer/main');//如果已经填写过信息
        //发送请求
        this.isajax = true;
        let data = res.mp.detail;
        if(data.errMsg == 'getUserInfo:ok'){
            let asyncFu = async()=>{
                let d = await this.$http.post(`${this.service}user/edit?access-token=${this.$store.state.access_token}`,{
                    nickname:data.userInfo.nickName,
                    avatar:data.userInfo.avatarUrl,
                    encryptedData:data.encryptedData,
                    iv:data.iv,
                    rawData:data.rawData,
                    signature:data.signature
                });
                if(d.status == 1){
                     this.linkFu();//执行跳转    
                }
            }
            asyncFu();
        }else{
            this.$refs.caiToast.showFu({
                 msg:'请先授权在进行操作',
                 time:1500
            })
            this.isajax = false; 
        }
     },
     appBtnFu1(res){
        let data = res.mp.detail;
        if(data.errMsg == 'getUserInfo:ok'){
            let asyncFu = async()=>{
                this.isRecording = !this.isRecording
            }
            asyncFu();
        }else{
            this.$refs.caiToast.showFu({
                 msg:'请先授权在进行操作',
                 time:1500
            })
            this.isajax = false; 
        }
     },
     recordingFn(){
         this.isRecording= ! this.isRecording
     },
     btnFu(){//h5接口
         if(this.start == 1){return;}
        //  this.validateFu();
        // var isanswer = this.wt.isanswer?true:false;
        // var isinfo = this.wt.msg?true:false;
        // let shuju = this.$http.get(`${this.service}questionnaire/status?access-token=${access_token}`);

        var token = window.localStorage.getItem('access_token');
        this.$http.get(`${this.service}questionnaire/status?access-token=${token}`).then((data)=>{
            console.log(data,123)
            var isanswer = data.isanswer;
            var isinfo = data.msg;
            if(isanswer == 1){//如果填写过打题
                this.$refs.caiToast.showFu({
                    msg:'你已经参加过此问卷调查，谢谢你的参与',
                    time:1500
                })
                return;
            }

            if(data.time != 1){
                this.$refs.caiToast.showFu({
                    msg:'不在活动时间内!',
                    time:1500
                })
                return;
            }
            //如果填写了信息直接跳转答题
            if(isinfo == 1){
                this.$router.push({ name: "answer" })
            }else{
                this.$router.push({ name: "info" })
            }
            this.linkFu()  
        });
        // var shuju = window.localStorage.getItem('sfzc');
       

         
        //  console.log(isinfo,12341234)



            
     },
     winBtnsFu(){//确定中奖信息按钮
        if(this.start == 1){return;}
        setTimeout(() => {
            this.isshow = false;
            if(this.iswin == 1){
                this.isRegister = true;
            }
        }, 150);
     },
     clearFu(){//重置按钮
        if(this.start == 1){return;}
        let asyncFu = async()=>{
            await this.$http.get(`${this.service}questionnaire/clear?access-token=${this.$store.state.access_token}`);
            let d = await this.$http.get(`${this.service}questionnaire/status?access-token=${this.$store.state.access_token}`);
            console.log(d);
            this.$store.commit('setStatus',d);
            this.$store.commit('setIsAward',-1);
            this.$refs.caiToast.showFu({
                 msg:'正在重置中',
                 time:1500
            })
            setTimeout(()=>{
                //this.$router.push({ path: '/pages/index/main', reLaunch: true })
                wx.reLaunch({
                    url:"/pages/index/main"
                })
                this.$router.push({ name: "/" })
            },1500)
        } 
        asyncFu();
        // if(this.start == 1){return;}
        // this.$http.get(`${this.service}questionnaire/clear?access-token=${this.$store.state.access_token}`).then((data)=>{            
        //      this.$http.get(`${this.service}questionnaire/status?access-token=${this.$store.state.access_token}`).then((data)=>{
        //          this.$store.commit('setStatus',data);
        //          this.$router.push({ path: '/pages/index/main', reLaunch: true })
        //     })
        // })
     },
     activity_idFu(){
         let asyncFu = async()=>{
            let d0 = await this.$http.get(`https://api.weixin.qq.com/cgi-bin/token?grant_type=client_credential&appid=wx108488299b9273db&secret=12aed4ade0db91e626b6bc6292ce2e1e`)
            // let d0 = await this.$http.get(`https://api.weixin.qq.com/cgi-bin/token?grant_type=client_credential&appid=wxbaab381536b8c8c6&secret=ac39fab9244d0e111fa7578ca509f216`)
            // let d0 = await this.$http.get(`https://api.weixin.qq.com/cgi-bin/token?grant_type=client_credential&appid=wx9eee6db48fe514b1&secret=6c7bad903bbc89f37a256fd4602d5ea2`)
            console.log(d0)
            if(d0.errcode){return;}
            let d1 = await this.$http.get(`https://api.weixin.qq.com/cgi-bin/message/wxopen/activityid/create?access_token=${d0.access_token}`);
            console.log(d1);
            this.$store.commit('setWx_access_token',{
                access_token:d0.access_token,
                activity_id:d1.activity_id
            });
            wx.updateShareMenu({
                withShareTicket: true,
                isUpdatableMessage: true,
                activityId: d1.activity_id, // 活动 ID
                templateInfo: {
                    parameterLis: [
                        {
                            name: 'member_count',
                            value: '1'
                        },
                        {
                            name: 'room_limit',
                            value: '3'
                        }
                    ]
                }
            })
         }
         asyncFu();
     },
  },
  onShareAppMessage(){//自定义转发
      return {
        title: '平安有我 民意收集',
        path: '/pages/index/main'
      }
    }
}
</script>

<style scoped lang="less">
@import '../../assets/css/less.less';
//清button样式
button::after{
   border:none;
}
button{ background: none; border: 0 none; padding: 0;
    display: flex; width: auto; margin: 0; line-height: 1;
}
.app{width: 100%; height: 100%; position: relative; .box;}
.app-img0{position: absolute; left: 0; top: 0; width: 100%; height: 100%;}
.app-con{ width: 100%; height: 100vh; position: relative; .box;}
.app-img1{ width: 100%; height: 100%;}
.app-btn{position: absolute; left: 50%; top: 73.7%; transform: translateX(-50%); width: 220/@r; height: 7.7%;
//   background: rgba(255,0,0,0.5);
}
.app-btn1{position: absolute; left: 50%; top: 780/@r; transform: translateX(-1.9rem); width: 180/@r; height: 7.7%;
//   background: rgba(255,0,0,0.5);
}
.app-btn2{position: absolute; left: 50%; top: 364/@r;; transform: translateX(-50%); width: 588/@r; height: 1.17rem;
//   background: rgba(255,0,0,0.5);
}
//中奖信息
.app-wins{position: fixed; left: 0; top: 0; z-index: 9; width: 100%; height: 100%; background: rgba(0,0,0,0.6);
   .box;
}
.app-win{.box; position: relative; width: 100%; height: 652/@r;}
.app-win img{width: 100%; height: 100%;}
.app-win-btns{ position: absolute; left: 50%; top: 502/@r; transform: translateX(-50%);
   width: 226/@r; height: 86/@r; 
   //background: rgba(255,0,0,0.5);
}
//重置
.app-clear{position: fixed; right: 50/@r; bottom: 50/@r; width: 100/@r; height: 100/@r; background: #f00;
   color: #fff; border-radius: 50%; .box; font-size: 34/@r;
}

</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue